let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cAcaY")).then(() => parcelRequire('h49zj'));